"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConfigurationPanel = void 0;

var _preact = require("preact");

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _ChevronRight = _interopRequireDefault(require("@insided/shared/icons/ChevronRight"));

var ConfigurationPanel = function ConfigurationPanel(_ref) {
  var isActive = _ref.isActive,
      title = _ref.title,
      children = _ref.children,
      togglePanel = _ref.togglePanel;
  return (0, _preact.h)("div", {
    className: "widget-configurator_tabs-wrapper"
  }, (0, _preact.h)("div", {
    className: "widget-configurator_tab homepage-widget-configurator_tab-template"
  }, (0, _preact.h)("div", {
    className: "widget-configurator_tab-header",
    role: "button",
    onClick: function onClick() {
      return togglePanel(isActive);
    },
    onKeyDown: function onKeyDown() {
      return togglePanel(isActive);
    }
  }, (0, _preact.h)("div", {
    className: "widget-configurator_tab-icon"
  }, isActive ? (0, _preact.h)(_ChevronDown.default, {
    width: 24,
    height: 24,
    fill: "#2B3346"
  }) : (0, _preact.h)(_ChevronRight.default, {
    width: 24,
    height: 24,
    fill: "#2B3346"
  })), (0, _preact.h)("span", {
    className: "widget-configurator_tab-title"
  }, title)), isActive ? (0, _preact.h)("div", {
    className: "widget-configurator_tab-content"
  }, children) : null));
};

exports.ConfigurationPanel = ConfigurationPanel;
var _default = ConfigurationPanel;
exports.default = _default;